class CollapsibleTab extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.collapsible-trigger');
    this.content = this.querySelector('.collapsible-content');

    if (!this.trigger || !this.content) return;

    this.trigger.addEventListener('click', () => this.toggle());
  }

  toggle() {
    const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';
    isOpen ? this.close() : this.open();
  }

  open() {
    this.content.style.height = this.content.scrollHeight + 'px';
    this.trigger.setAttribute('aria-expanded', 'true');
    this.trigger.classList.add('is-open');
    this.content.classList.add('is-open');

    this.content.addEventListener('transitionend', () => {
      this.content.style.height = 'auto';
    }, { once: true });
  }

  close() {
    this.content.style.height = this.content.scrollHeight + 'px';

    // Force reflow before transitioning to 0
    this.content.getBoundingClientRect();

    this.content.style.height = '0';
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.classList.remove('is-open');
    this.content.classList.remove('is-open');
  }
}

customElements.define('collapsible-tab', CollapsibleTab);
